import { useAppDispatch, useAppState } from '@/store';
import { useEffect, useMemo } from 'react';
import { getFeedbacks, feedbacksSelector, resetFeedbackList } from '../feature';
import { FeedbackType } from '@/models/feedback.model';

const useGetFeedBacks = (type: FeedbackType) => {
  const dispatch = useAppDispatch();
  const data = useAppState(feedbacksSelector);

  useEffect(() => {
    dispatch(
      getFeedbacks({
        page: 1,
        type,
      }),
    );
  }, [dispatch, type]);

  useEffect(
    () => () => {
      dispatch(resetFeedbackList(type));
    },
    [dispatch, type],
  );

  return useMemo(
    () => ({
      list: data[type]?.list,
      pagination: data[type]?.pagination,
      query: data.query,
      isLoading: data[type]?.isLoading,
      error: data[type]?.error,
    }),
    [data, type],
  );
};

export default useGetFeedBacks;
